import React from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

const SMS_CARDS = [
    {
        title: "SMS Templates",
        link: "templates",
        icon: "bi-file-earmark-text",
        color: "green",
        desc: "Admin: country-wise SMS templates",
    },
    {
        title: "Send SMS",
        link: "send",
        icon: "bi-send",
        color: "blue",
        desc: "Single or bulk SMS campaigns",
    },
    {
        title: "Received SMS",
        link: "received",
        icon: "bi-chat-left-text",
        color: "pink",
        desc: "Incoming messages from clients",
    },
];

export default function SmsHub() {
    const getRole = Cookies.get("user_role");
    const getUsername = Cookies.get("username");

    if (getRole !== "Administrator") {
        return (
            <div className="container">
                <div className="crm-page-header">
                    <h1 className="crm-page-title">Access Denied</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="crm-page-header">
                <h1 className="crm-page-title">SMS Management</h1>
                <p className="crm-page-subtitle">
                    Welcome, {getUsername} — Twilio SMS tools (templates, bulk send, inbox)
                </p>
            </div>

            <div className="crm-stat-grid">
                {SMS_CARDS.map((card) => (
                    <Link key={card.title} to={`/sms/${card.link}`} className="crm-stat-card">
                        <div className={`crm-stat-card-icon crm-stat-card-icon--${card.color}`}>
                            <i className={`bi ${card.icon}`}></i>
                        </div>
                        <div className="crm-stat-card-label">{card.title}</div>
                        <div
                            className="crm-stat-card-value"
                            style={{ fontSize: "0.95rem", fontWeight: 500 }}
                        >
                            {card.desc}
                        </div>
                        <span className="crm-stat-card-link">
                            Open <i className="bi bi-arrow-right"></i>
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
